module.exports = __webpack_public_path__ + "img/radio.1db061a7.svg";